import { render, staticRenderFns } from "./PrintFacturae.vue?vue&type=template&id=6f28ce8d&scoped=true"
import script from "./PrintFacturae.vue?vue&type=script&lang=js"
export * from "./PrintFacturae.vue?vue&type=script&lang=js"
import style0 from "./PrintFacturae.vue?vue&type=style&index=0&id=6f28ce8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f28ce8d",
  null
  
)

export default component.exports